import { render } from "./InputTextSingle.vue?vue&type=template&id=58a1b549"
import script from "./InputTextSingle.vue?vue&type=script&lang=js"
export * from "./InputTextSingle.vue?vue&type=script&lang=js"
script.render = render

export default script